mutation assignValuationToLead($input: AssignValuationToLeadInput!) {
  valuation: assignValuationToLead(input: $input) {
    id
    leadId
  }
}
